/// <amd-module name="Pipeline/Analytics/PipelineStepsDurationCard/Common/StackedBarChartDataHelper" />
import { getPercentage } from "Analytics/Shared/Utils/Number";
import { getStackedBarChartData } from "Pipeline/Analytics/Common/ChartHelper/StackedBarChartDataSelector";
import { maxItemsToShowInCharts } from "Pipeline/Analytics/Common/Constants";
import { colors } from "Pipeline/Analytics/Common/Constants";
import * as TelemetryConstants from "Pipeline/Analytics/Common/Telemetry/TelemetryConstants";
import { IAnalyticsChartProps } from "Pipeline/Analytics/Common/Types";
import * as Resources from "Pipeline/Analytics/PipelineStepsDurationCard/Resources";
import { IStageStepsDurationData, IStepDurationData } from "Pipeline/Analytics/PipelineStepsDurationCard/Types";
import { ChartProps } from "VSS/Features/Charts/Contracts";
import { IVssPageContext } from "VSS/Platform/Context";

export function getStackedBarChartProps(pageContext: IVssPageContext, data: IStageStepsDurationData, stageName: string): ChartProps {
    let i = 0;
    const topStepDurationData: IStepDurationData[] = data.stepDurationData[stageName].stepsData.slice(0, maxItemsToShowInCharts);
    const series = topStepDurationData.map(duration => {
        return {
            name: duration.stepName,
            data: [getPercentage(data.stepDurationData[stageName].totalStageStepDuration, duration.stepDuration)],
            color: colors[i++]
        };
    });

    const chartData = {
        title: Resources.StackedBarChartTitle,
        series: series,
        telemetryArea: TelemetryConstants.feature_PipelineStepsDurationCard
    } as IAnalyticsChartProps;
    return getStackedBarChartData(pageContext, chartData);
}
